module.exports = __webpack_public_path__ + "static/media/iconCanvas10.16e1c0ef.svg";